import { FC, MouseEvent } from 'react';
import Prev from './components/prev/prev';
import Next from './components/next/next';
import Last from './components/last/last';
import First from './components/first/first';
import Input from './components/input/input';
import { IPagination, PAGINATION_BUTTON_COLOR } from '../../table.types';
import { getPaginationButtonActiveColor } from './pagination-button-color';
import './pagination.scss';

export interface IPaginationProps extends IPagination {
    totalResultsTitle: string;
}

const Pagination: FC<IPaginationProps> = ({
    onSetPage,
    page,
    total,
    perPage,
    totalResultsTitle,
    buttonColor = PAGINATION_BUTTON_COLOR.THEME,
}) => {
    const totalPages = Math.ceil(total / perPage);
    if (totalPages < 1) {
        return null;
    }

    const activeColor = getPaginationButtonActiveColor(buttonColor);

    const onNextHandler = (e: MouseEvent<HTMLElement>) => {
        onSetPage(page + 1)
    }

    const onLastHandler = (e: MouseEvent<HTMLElement>) => {
        onSetPage(totalPages);
    }

    const onPrevHandler = (e: MouseEvent<HTMLElement>) => {
        onSetPage(page - 1);
    }

    const onFirstHandler = (e: MouseEvent<HTMLElement>) => {
        onSetPage(1);
    }

    return (
        <div className="pagination-wrapper">
            <div className="results-wrapper">
                {total} {totalResultsTitle}
            </div>
            <div className="pagination" role="navigation">
                <First
                    isActive={page > 1}
                    onClick={onFirstHandler}
                    activeColor={activeColor}
                />
                <Prev
                    isActive={page > 1}
                    onClick={onPrevHandler}
                    activeColor={activeColor}
                />
                <div className='page-indicator'>
                    <span>Page</span>
                    <Input
                        page={page}
                        totalPages={totalPages}
                        onSetPage={onSetPage}
                    /> / {totalPages}
                </div>
                <Next
                    isActive={page < totalPages}
                    onClick={onNextHandler}
                    activeColor={activeColor}
                />
                <Last
                    isActive={page < totalPages}
                    onClick={onLastHandler}
                    activeColor={activeColor}
                />
            </div>
        </div>
    );
}

export default Pagination;
